module.exports = __webpack_public_path__ + "img/114.1b255e68.jpg";